import { useState } from 'react';
import { motion } from 'framer-motion';
import { useWalletStore } from '../store/useWalletStore';
import { useWebAuthn } from '../hooks/useWebAuthn';
import { registerDeviceLocal } from '../services/local-api';
import { v4 as uuidv4 } from 'uuid';

export function Onboarding() {
  const { createWallet } = useWalletStore();
  const [label, setLabel] = useState('My Phone');
  const [busy, setBusy] = useState(false);
  const { buildCreationOptions, createCredential } = useWebAuthn();

  async function start() {
    setBusy(true);
    try {
      const challenge = btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(32)))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
      const walletId = uuidv4();
      const opts = buildCreationOptions({ challenge, rpId: location.hostname, userId: walletId, userName: 'anonymous' });
      const cred = await createCredential(opts);
      await registerDeviceLocal({ walletId, deviceId: cred.id, label, publicKeySpki: cred.publicKeySpki || null });
      createWallet(label);
    } catch (e) {
      alert((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="mt-10">
      <h2 className="text-lg font-medium mb-2">Welcome</h2>
      <p className="text-slate-300 mb-4">Create your device-bound wallet. Your device will protect your keys with biometrics/PIN.</p>
      <div className="space-y-3">
        <label className="block">
          <span className="text-sm text-slate-400">Primary device label</span>
          <input value={label} onChange={e=>setLabel(e.target.value)} className="mt-1 w-full rounded border border-slate-700 bg-slate-900 px-3 py-2" />
        </label>
        <button onClick={start} disabled={busy} className="rounded bg-emerald-600 px-4 py-2 hover:bg-emerald-500 disabled:opacity-50">
          {busy ? 'Setting up…' : 'Create Wallet'}
        </button>
      </div>
    </motion.div>
  );
}


